import apiClient from './apiClient';
import { GET_EVENT_SETTINGS, UPDATE_EVENT_SETTINGS } from '../constants/UriConstants';
import { EventSettingsInterface, UpdateEventSettingsRequest } from '../types/EventSettingsInterface';

export const getEventSettings = (): Promise<EventSettingsInterface> =>
  apiClient.get(GET_EVENT_SETTINGS).then((response) => response.data);

export const updateEventSettings = (update: UpdateEventSettingsRequest): Promise<EventSettingsInterface> =>
  apiClient.put(UPDATE_EVENT_SETTINGS, update).then((response) => response.data);
